"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalConfirmAction = void 0;
var react_1 = __importStar(require("react"));
var ModalConfirm_1 = require("../../ModalConfirm");
/**
 * @component Renders a modal confirmation action component with customizable text, buttons and styling.
 *
 * - The props object containing the following properties:
 * @prop {React.ReactNode} children: The content to be rendered inside the button.
 * @prop {boolean} enabled: A boolean indicating whether the component is enabled or not. Defaults to false.
 * @prop {string} title: The title to be displayed in the modal.
 * @prop {string} subtitle: The subtitle to be displayed in the modal.
 * @prop {string} onConfirmText: The text to be displayed in the confirm button. Defaults to "Confirm".
 * @prop {string} onCloseText: The text to be displayed in the close button. Defaults to "Cancel".
 * @return {ReactElement} The rendered modal confirm action component.
 */
var ModalConfirmAction = function (_a) {
    var children = _a.children, _b = _a.enabled, enabled = _b === void 0 ? false : _b, _c = _a.title, title = _c === void 0 ? "Are you sure you want to do this action?" : _c, subtitle = _a.subtitle, onConfirmText = _a.onConfirmText, onCloseText = _a.onCloseText;
    var _d = (0, react_1.useState)(false), modal = _d[0], setModal = _d[1];
    var callback;
    var handleParentClick = function (e) {
        // usecase: actionMenu in table
        e.stopPropagation();
        setModal(e);
    };
    var handleConfirm = function () {
        callback(modal);
        setModal(false);
    };
    var getChildren = function () {
        if (!enabled) {
            return children;
        }
        else {
            return react_1.default.Children.map(children, function (child) {
                // Check if the child is a React component
                if (react_1.default.isValidElement(child)) {
                    // Access props of the child component
                    callback = child.props.onClick;
                    return (0, react_1.cloneElement)(child, { onClick: handleParentClick });
                }
                // Return non-component children as they are
                return child;
            });
        }
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        modal ? (react_1.default.createElement(ModalConfirm_1.ModalConfirm, { title: title, subTitle: subtitle, onClose: function () { return setModal(false); }, onConfirmText: onConfirmText, onConfirm: handleConfirm, onCloseText: onCloseText })) : null,
        getChildren()));
};
exports.ModalConfirmAction = ModalConfirmAction;
